module.exports = __webpack_public_path__ + "img/phoneBanner6.d73f59f2.jpg";